import type { ReactNode } from "react";
import { Loader } from "@/components/common/loader";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface Props {
  title: string;
  description?: string;
  loading?: boolean;
  error?: boolean;
  action?: ReactNode;
  children: ReactNode;
}

/** Card frame for a reference-data page — title/description + consistent
 * loading/error states (mirrors settings' TabShell, kept local to the feature). */
export function ReferencePanel({ title, description, loading, error, action, children }: Props) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between gap-4">
        <div>
          <CardTitle>{title}</CardTitle>
          {description && <CardDescription>{description}</CardDescription>}
        </div>
        {action}
      </CardHeader>
      <CardContent>
        {error ? (
          <p className="text-destructive text-sm">
            Couldn&apos;t load this section. Please refresh and try again.
          </p>
        ) : loading ? (
          <div className="flex justify-center py-12">
            <Loader />
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
